@if (isVisible) {
  <div class="container-out" (click)="close()"></div>
}

@if (isVisible) {
  <div class="container-notification-info slide-bottom">
    <div class="title-notification">
      <h2>Notificações</h2>
      @if (listMessage != null && listMessage.length > 0) {
        <span class="read-all" (click)="readAll()"> Marcar todas como lidas
          <mat-icon class="icon-transform" aria-hidden="false" aria-label="Menu apps" (click)="readAll()">
            mark_chat_unread
          </mat-icon>
        </span>
      }
    </div>
    @if (listMessage == null || listMessage.length == 0) {
      <div class="text-center">
        <img class="no-notification-image" src="/assets/images/notification-image.webp">
        <p>Você ainda não possui novas notificações.</p>
      </div>
    }
    @if (isLoading) {
      <app-loading-progress-bar></app-loading-progress-bar>
    }
    <div class="action">
      @if (listMessage != null && listMessage.length > 0) {
        <ul>
          <div class="list-container">
            @for (item of listMessage; track item; let i = $index) {
              <ngContainer>
                <li>
                  @if ((!isModalView && !item.isRead) || (isModalView && item.idMessage != idSelectedMessage && !item.isRead)) {
                    <a-unread
                      >
                      <span><b>{{item.messageTitle}}</b></span>
                      <div class="container-message" contenteditable="false" [innerHTML]="item.messageContent"
                        (click)="openViewModal(item, i)">
                      </div>
                      <mat-icon class="chevron" matTooltip="Deletar" aria-hidden="false" aria-label="Menu apps"
                      (click)="singleDelete(item)">delete_sweep</mat-icon>
                      <date>{{item.datetimeInclusion | date:'dd/MM/yy, H:mm'}}</date>
                    </a-unread>
                  }
                  @if (isModalView && item.idMessage == idSelectedMessage) {
                    <a-selected>
                      <span><b>{{item.messageTitle}}</b></span>
                      <div class="container-message" contenteditable="false" [innerHTML]="item.messageContent"
                        (click)="openViewModal(item, i)">
                      </div>
                      <mat-icon class="chevron" matTooltip="Deletar" aria-hidden="false" aria-label="Menu apps"
                      (click)="singleDelete(item)">delete_sweep</mat-icon>
                      <date>{{item.datetimeInclusion | date:'dd/MM/yy, H:mm'}}</date>
                    </a-selected>
                  }
                  @if ((!isModalView && item.isRead) || (isModalView && item.idMessage != idSelectedMessage && item.isRead)) {
                    <a-read
                      >
                      <span><b>{{item.messageTitle}}</b></span>
                      <div class="container-message" contenteditable="false" [innerHTML]="item.messageContent"
                        (click)="openViewModal(item, i)">
                      </div>
                      <mat-icon matTooltip="Deletar" class="chevron" aria-hidden="false" aria-label="Menu apps"
                      (click)="singleDelete(item)">delete_sweep</mat-icon>
                      <date>{{item.datetimeInclusion | date:'dd/MM/yy, H:mm'}}</date>
                    </a-read>
                  }
                  <div class="title-header"></div>
                </li>
              </ngContainer>
            }
          </div>
        </ul>
      }
    </div>
    <div>
      @if (listMessage != null && listMessage.length > 0) {
        <span class="delete-all" (click)="deleteAll()">Limpar
        notificações</span>
      }
    </div>
  </div>
}